import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';

type SortOption = {
  label: string;
  value: string;
};

type SortByProps = {
  options: SortOption[];
  defaultValue?: string;
  onChange: (value: string) => void;
};

const SortBy: React.FC<SortByProps> = ({ options, defaultValue, onChange }) => {
  const { t } = useTranslation('dashboard');
  // RV-125。同じ画面に並び替えが複数あっても label と選択欄の id が重ならないようにする。
  const selectId = useId();

  return (
    // Adjusted classes for vertical centering and flex display
    <div className="flex min-w-fit items-center border-r px-4 py-2">
      <label htmlFor={selectId} className="text-neutral/100">
        {t('table.sort')}
      </label>
      <select
        id={selectId}
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        className="focus:outline-none font-regular text-neutral/100 px-2"
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SortBy;
